import { Injectable } from '@angular/core';
import { alert } from 'devextreme/ui/dialog';
import { DataCoreService } from '../data-core.service';
import {
  GisAdresHedefTuru,
  GisAdresKaynagi,
  GisHaritaHedefi,
  GisMahalleCadde,
  gisAdresHedefi,
  gisAdresHedefUyarisi,
} from './gis-adres-hedefi';

/** Adres bloklarındaki harita butonlarının ortak mantığı. */
@Injectable({ providedIn: 'root' })
export class GisAdresService {
  private readonly mahalleCaddeCache = new Map<number, Promise<GisMahalleCadde | null>>();

  constructor(private dataCoreService: DataCoreService) {}

  /**
   * Butonun göstereceği harita nesnesini bulur. Gösterilecek kod yoksa kullanıcıyı uyarır ve null döner.
   * CADDE / MAHALLE için MahalleCaddeKod, GenMahalleCaddeSokak üzerinden mahalle ve caddeye çözülür.
   */
  async hedefBul(tur: GisAdresHedefTuru, kaynak: GisAdresKaynagi): Promise<GisHaritaHedefi | null> {
    const mahalleCadde = tur === 'CADDE' || tur === 'MAHALLE'
      ? await this.mahalleCaddeCoz(kaynak.mahalleCaddeKod)
      : null;
    const hedef = gisAdresHedefi(tur, kaynak, mahalleCadde);
    if (!hedef) alert(gisAdresHedefUyarisi(tur), 'Uyarı!');
    return hedef;
  }

  /** MahalleCaddeKod (GenMahalleCaddeSokak.Kod) → bağlı olduğu mahalle ve cadde. */
  mahalleCaddeCoz(mahalleCaddeKod: number | null | undefined): Promise<GisMahalleCadde | null> {
    const kod = Number(mahalleCaddeKod);
    if (mahalleCaddeKod == null || !Number.isFinite(kod) || kod <= 0) return Promise.resolve(null);

    let sonuc = this.mahalleCaddeCache.get(kod);
    if (!sonuc) {
      const ds = this.dataCoreService.getOData('GenMahalleCaddeSokak');
      ds.select(['Kod', 'MahalleKod', 'CaddeSokakKod']);
      ds.filter(['Kod', '=', kod]);
      sonuc = ds.load()
        .then((rows: any[]) => rows?.length
          ? { mahalleKod: rows[0].MahalleKod ?? null, caddeSokakKod: rows[0].CaddeSokakKod ?? null }
          : null)
        .catch(() => {
          this.mahalleCaddeCache.delete(kod);
          return null;
        });
      this.mahalleCaddeCache.set(kod, sonuc);
    }
    return sonuc;
  }
}
